import React, { useState } from 'react'
import Title from '../layouts/Title';
import Reveal from '../layouts/Reveal';
import ContactLeft from './ContactLeft';
import { profile } from '../../constants';

const initialForm = { username: "", phoneNumber: "", email: "", subject: "", message: "" };

const Field = ({ id, label, invalid, children }) => (
  <div className="w-full flex flex-col gap-4">
    <label htmlFor={id} className="text-sm text-gray-400 uppercase tracking-wide">
      {label}
    </label>
    {React.cloneElement(children, {
      id,
      "aria-invalid": invalid,
      className: `${invalid ? "outline outline-1 outline-designColor" : ""} ${children.props.className}`,
    })}
  </div>
);

const Contact = () => {
  const [form, setForm] = useState(initialForm);
  const [errField, setErrField] = useState("");
  const [errMsg, setErrMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  const update = (field) => (e) => setForm({ ...form, [field]: e.target.value });

  // ========== Email Validation start here ==============
  const emailValidation = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  // ========== Email Validation end here ================

  const fail = (field, msg) => {
    setErrField(field);
    setErrMsg(msg);
    setSuccessMsg("");
  };

  const handleSend = (e) => {
    e.preventDefault();
    const { username, phoneNumber, email, subject, message } = form;
    if (!username.trim()) return fail("username", "Please tell me your name!");
    if (!email.trim()) return fail("email", "Please give your Email!");
    if (!emailValidation(email)) return fail("email", "Give a valid Email!");
    if (!subject.trim()) return fail("subject", "Please give your Subject!");
    if (!message.trim()) return fail("message", "Message is required!");

    // No backend: hand the message to the visitor's mail client, pre-filled.
    const body = [
      message,
      "",
      `— ${username}`,
      email,
      phoneNumber && `Phone: ${phoneNumber}`,
    ]
      .filter((line) => line !== "")
      .join("\n");
    window.location.href = `mailto:${profile.email}?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;

    setErrField("");
    setErrMsg("");
    setSuccessMsg(
      `Thanks ${username}! Your email app should open with the message ready to send.`
    );
    setForm(initialForm);
  };

  return (
    <section
      id="contact"
      className="sectionWrap"
    >
      <div className="flex justify-center items-center text-center">
        <Title title="Get In Touch" des="Let's Work Together" />
      </div>
      <Reveal className="w-full">
        <div className="w-full h-auto flex flex-col lgl:flex-row gap-8 justify-between">
          <ContactLeft />
          <div className="card w-full lgl:w-[60%] h-full py-10 flex flex-col gap-8 p-5 lgl:p-10">
            <form
              onSubmit={handleSend}
              noValidate
              className="w-full flex flex-col gap-4 lgl:gap-6 py-2 lgl:py-5"
            >
              <div className="w-full flex flex-col lgl:flex-row gap-4 lgl:gap-10">
                <Field id="username" label="Your name" invalid={errField === "username"}>
                  <input onChange={update("username")} value={form.username} className="contactInput" type="text" autoComplete="name" />
                </Field>
                <Field id="phoneNumber" label="Phone Number (optional)">
                  <input onChange={update("phoneNumber")} value={form.phoneNumber} className="contactInput" type="tel" autoComplete="tel" />
                </Field>
              </div>
              <Field id="email" label="Email" invalid={errField === "email"}>
                <input onChange={update("email")} value={form.email} className="contactInput" type="email" autoComplete="email" />
              </Field>
              <Field id="subject" label="Subject" invalid={errField === "subject"}>
                <input onChange={update("subject")} value={form.subject} className="contactInput" type="text" />
              </Field>
              <Field id="message" label="Message" invalid={errField === "message"}>
                <textarea onChange={update("message")} value={form.message} className="contactTextArea" cols="30" rows="8"></textarea>
              </Field>
              <div className="w-full">
                <button
                  type="submit"
                  className="w-full h-12 bg-designColor rounded-full text-base text-white tracking-wider uppercase shadow-lg shadow-designColor/30 hover:-translate-y-1 duration-300"
                >
                  Send Message
                </button>
              </div>
              <div aria-live="polite">
                {errMsg && (
                  <p className="py-3 rounded-xl bg-black/20 text-center text-orange-500 text-base tracking-wide">
                    {errMsg}
                  </p>
                )}
                {successMsg && (
                  <p className="py-3 rounded-xl bg-black/20 text-center text-green-500 text-base tracking-wide">
                    {successMsg}
                  </p>
                )}
              </div>
            </form>
          </div>
        </div>
      </Reveal>
    </section>
  );
}

export default Contact
